<div class="painel-camadas">
  <h6 class="painel-camadas-titulo">{{ 'COMPONENTS.MAPA.LAYERS_PANEL.title' | transloco }}</h6>
  <hr />
  <ul *ngIf="camadas$ | async as camadas">
    <li>
      <label class="camada-switch-row">
        <span class="item-label">
          <span class="dot dot-parada"></span>
          {{ 'COMPONENTS.MAPA.LAYERS_PANEL.stops' | transloco }}
        </span>
        <span class="camada-switch">
          <input type="checkbox" [checked]="camadas.stops" (change)="alternar('stops')">
          <span class="slider"></span>
        </span>
      </label>
    </li>
    <li>
      <label class="camada-switch-row">
        <span class="item-label">
          <img src="assets/mapa/filtros/tratores.svg" alt="" class="item-icone" />
          {{ 'COMPONENTS.MAPA.LAYERS_PANEL.tractors' | transloco }}
        </span>
        <span class="camada-switch">
          <input type="checkbox" [checked]="camadas.tractors" (change)="alternar('tractors')">
          <span class="slider"></span>
        </span>
      </label>
    </li>
    <li>
      <label class="camada-switch-row">
        <span class="item-label">
          <img src="assets/mapa/filtros/fazenda.png" alt="" class="item-icone" />
          {{ 'COMPONENTS.MAPA.LAYERS_PANEL.farms' | transloco }}
        </span>
        <span class="camada-switch">
          <input type="checkbox" [checked]="camadas.farms" (change)="alternar('farms')">
          <span class="slider"></span>
        </span>
      </label>
    </li>
    <li>
      <label class="camada-switch-row">
        <span class="item-label">
          <span class="dot dot-plantando"></span>
          {{ 'COMPONENTS.MAPA.LAYERS_PANEL.planting_track' | transloco }}
        </span>
        <span class="camada-switch">
          <input type="checkbox" [checked]="camadas.planting_track" (change)="alternar('planting_track')">
          <span class="slider"></span>
        </span>
      </label>
    </li>
    <li>
      <label class="camada-switch-row">
        <span class="item-label">
          <span class="dot dot-deslocando"></span>
          {{ 'COMPONENTS.MAPA.LAYERS_PANEL.displacement_track' | transloco }}
        </span>
        <span class="camada-switch">
          <input type="checkbox" [checked]="camadas.displacement_track" (change)="alternar('displacement_track')">
          <span class="slider"></span>
        </span>
      </label>
    </li>
    <li>
      <label class="camada-switch-row">
        <span class="item-label">
          <span class="dot dot-manobrando"></span>
          {{ 'COMPONENTS.MAPA.LAYERS_PANEL.maneuvering_track' | transloco }}
        </span>
        <span class="camada-switch">
          <input type="checkbox" [checked]="camadas.maneuvering_track" (change)="alternar('maneuvering_track')">
          <span class="slider"></span>
        </span>
      </label>
    </li>
  </ul>
</div>
